module.exports = __webpack_public_path__ + "static/media/thanks.18212ff1.png";